"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedemptionServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
class RedemptionServiceLive {
    async getRedemptionSettings(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/redemption-settings`);
        return response.data;
    }
    async updateRedemptionSettings(companyId, settings) {
        const response = await HttpProvider_1.httpProvider.put(`/company/${companyId}/redemption-settings`, settings);
        return response.data;
    }
    async createRedemption(companyId, shareholderId, body) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/shareholders/${shareholderId}/redemptions`, body);
        return response.data;
    }
    async getRedemptions(companyId, query = {}) {
        // HttpProvider.get sends its second argument as the request body, which axios omits for GET,
        // so query params must be encoded into the URL.
        const search = new URLSearchParams();
        if (query.filter) {
            search.set("filter", query.filter);
        }
        if (query.q) {
            search.set("q", query.q);
        }
        if (query.shareholderId) {
            search.set("shareholderId", query.shareholderId);
        }
        const queryString = search.toString();
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/redemptions${queryString ? `?${queryString}` : ""}`);
        return response.data;
    }
    async getShareholderRedemptions(companyId, shareholderId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/shareholders/${shareholderId}/redemptions`);
        return response.data;
    }
    async getRedemption(companyId, redemptionId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/redemptions/${redemptionId}`);
        return response.data;
    }
    async cancelRedemption(companyId, shareholderId, redemptionId, txHash) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/shareholders/${shareholderId}/redemptions/${redemptionId}/cancel`, txHash ? { txHash } : {});
        return response.data;
    }
    async recordRedemptionVaultTransaction(companyId, shareholderId, redemptionId, txHash) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/shareholders/${shareholderId}/redemptions/${redemptionId}/vault-transactions`, { txHash });
        return response.data;
    }
    async acceptRedemption(companyId, redemptionId, body) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/redemptions/${redemptionId}/accept`, body);
        return response.data;
    }
    async rejectRedemption(companyId, redemptionId, body) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/redemptions/${redemptionId}/reject`, body);
        return response.data;
    }
    async decideOutOfBand(companyId, redemptionId, body) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/redemptions/${redemptionId}/out-of-band`, body);
        return response.data;
    }
    async approveWindow(companyId, windowKey, body) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/redemptions/window/${encodeURIComponent(windowKey)}/approve`, body);
        return response.data;
    }
    async completeWindow(companyId, windowKey) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/redemptions/window/${encodeURIComponent(windowKey)}/payment-made`, {});
        return response.data;
    }
    async confirmPaymentMade(companyId, redemptionId) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/redemptions/${redemptionId}/payment-made`, {});
        return response.data;
    }
    async getWindowAbaFile(companyId, windowKey) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/redemptions/window/${encodeURIComponent(windowKey)}/aba`);
        return response.data;
    }
    async getWindowManualPayments(companyId, windowKey) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/redemptions/window/${encodeURIComponent(windowKey)}/manual-payments`);
        return response.data;
    }
    async getRedemptionAbaFile(companyId, redemptionId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/redemptions/${redemptionId}/aba`);
        return response.data;
    }
    async getRedemptionNotice(companyId, shareholderId, redemptionId, timestamp) {
        const queryString = timestamp !== undefined ? `?timestamp=${timestamp}` : "";
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/shareholders/${shareholderId}/redemptions/${redemptionId}/statement${queryString}`);
        return response.data;
    }
    async getRedemptionTransactions(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/redemptions/transactions`);
        return response.data;
    }
}
exports.RedemptionServiceLive = RedemptionServiceLive;
//# sourceMappingURL=RedemptionServiceLive.js.map